/** Base App */
import Vue from "vue";
import App from "./App.vue";
/** Store & Router */
import store from "./store/store";
import router from "./router";
/** App plugins */
import worldPlugin from "../../../world/spa/libs/world-plugin";
import calendarPlugin from "../../../calendar/spa/libs/calendar-plugin";
/** WebGraphics Global Plugin */
import WebGraphics from "../../../world/spa/libs/wg-global-plugin";
/** WorldMenu Plugin */
import WorldMenu from "../../../world/spa/libs/menu-plugin";
/** WorldHeadbar Plugin */
import WorldHeadbar from "../../../world/spa/libs/headbar-plugin";
/** WGModal plugin */
import WGModal from "../../../world/spa/libs/modal-plugin";
/** Offline plugin */
import Offline from "../../../world/spa/libs/offline-plugin";
/** Auth plugin */
import Auth from "../../../world/spa/libs/auth-plugin";
/** Custom implementation of axios */
import axiosPlugin from "../libs/axios";
/** Local forage */
import localforagePlugin from "../libs/localForage";
/** Moment.js plugin to manage dates - using fork to prevent console warnings */
// import VueMoment from 'vue-moment';
import VueMoment from "../../../world/spa/libs/vue-moment-fork";
import moment from "moment";
import "moment/locale/it";
import momentTimezone from "moment-timezone";
/* Top progress bar */
import VueProgressBar from "vue-progressbar";
/** Service Worker */
import "./registerServiceWorker";
/* QRCode generator */
import VueQrcode from "@chenfengyuan/vue-qrcode";

Vue.config.productionTip = false;
// Vue.config.silent = process.env.NODE_ENV === 'production' ? true : false;
// Da eliminare quando si va in produzione, usare solo in caso estremo
// Vue.config.devTools = true;

Vue.use(worldPlugin);
Vue.use(calendarPlugin);

Vue.component(VueQrcode.name, VueQrcode);

Vue.use(VueProgressBar, {
  color: "red",
  failedColor: "red",
  height: "2px",
  position: "fixed",
});

// Configurazione di Vue-localforage
Vue.use(localforagePlugin);

// Axios come $http in Vue, disponibile globalmente
Vue.use(axiosPlugin);

Vue.use(VueMoment, {
  moment,
  momentTimezone,
});

/**
 * WebGraphics
 */
Vue.use(WebGraphics, { store });

/**
 * WGModal
 */
Vue.use(WGModal, { store });

/**
 * Menu World
 */
Vue.use(WorldMenu, { store });

/**
 * Headbar World
 */
Vue.use(WorldHeadbar, { store });

/**
 * Offline plugin
 */
Vue.use(Offline, { store });

Vue.use(Auth, { store });

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
